export default __webpack_public_path__ + "img/41b9a128059b0ee80be134bb2edd7549.png";